import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check } from 'lucide-react'

import './checkbox.css'
export function Checkbox({ className = '', ...props }) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={`checkbox ${className}`}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="checkbox-indicator"
      >
        <Check className="checkbox-icon" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}
